import React from "react";

const Card = ({ icon, label, value, variant, active, onClick }) => (
  <button
    type="button"
    className={`emp-card rrhh-summary-card ${variant} ${active ? "active" : ""} p-3 rounded-3 border-0 w-100`}
    onClick={onClick}
  >
    <div className="d-flex align-items-center gap-3">
      <div className="management-stat-icon d-flex align-items-center justify-content-center rounded-3 p-2">
        <i className={`${icon} fs-5`} />
      </div>
      <div className="text-start">
        <div className="fw-bold fs-5 lh-1">{value}</div>
        <div className="management-label mt-1">{label}</div>
      </div>
    </div>
  </button>
);

export default function EmpleadosSummary({ resumen = {}, onQuickFilter, activeKey }) {
  const cards = [
    { key: "total",          icon: "bi bi-people",         label: "Total",         value: resumen.total ?? 0,          variant: "total" },
    { key: "activos",        icon: "bi bi-person-check",   label: "Activos",       value: resumen.activos ?? 0,        variant: "success" },
    { key: "docentes",       icon: "bi bi-mortarboard",    label: "Docentes",      value: resumen.docentes ?? 0,       variant: "info" },
    { key: "administrativos",icon: "bi bi-briefcase",      label: "Administrativos",value: resumen.administrativos ?? 0, variant: "secondary" },
    { key: "servicios",      icon: "bi bi-wrench",         label: "Servicios",     value: resumen.servicios ?? 0,      variant: "warning" },
    { key: "enNomina",       icon: "bi bi-cash-coin",      label: "En nómina",     value: resumen.enNomina ?? 0,       variant: "success" },
    { key: "porServicios",   icon: "bi bi-file-earmark-text", label: "Facturan",   value: resumen.porServicios ?? 0,   variant: "info" },
  ];

  return (
    <div className="management-card mb-4">
      <div className="emp-summary-grid">
        {cards.map((c) => (
          <Card key={c.key} {...c} active={activeKey === c.key} onClick={() => onQuickFilter?.(c.key)} />
        ))}
      </div>
    </div>
  );
}
